// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Utils$OrcaPaymentPage from "../Utilities/Utils.bs.js";
import * as Loader$OrcaPaymentPage from "./Loader.bs.js";

function PaymentLoader(props) {
  let match = React.useState(() => "auto");
  let setBranding = match[1];
  let branding = match[0];
  React.useEffect(() => {
    Utils$OrcaPaymentPage.messageParentWindow(undefined, [[
        "iframeMountedCallback",
        true
      ]]);
    let handle = ev => {
      let json = Utils$OrcaPaymentPage.safeParse(ev.data);
      let dict = Utils$OrcaPaymentPage.getDictFromJson(json);
      if (Utils$OrcaPaymentPage.getBool(dict, "fullScreenIframeMounted", false) && Core__Option.isSome(Utils$OrcaPaymentPage.getOptionString(Utils$OrcaPaymentPage.getDictFromDict(dict, "options"), "branding"))) {
        return setBranding(param => Utils$OrcaPaymentPage.getString(Utils$OrcaPaymentPage.getDictFromDict(dict, "options"), "branding", "auto"));
      }
    };
    window.addEventListener("message", handle);
    return () => {
      window.removeEventListener("message", handle);
    };
  }, []);
  let styles = branding === "auto" ? "backdrop-blur-md bg-black/80" : "backdrop-contrast-125 backdrop-blur-2xl opacity-70 bg-black/80";
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsx("div", {
      children: JsxRuntime.jsx(Loader$OrcaPaymentPage.make, {
        branding: branding
      }),
      className: `flex flex-col justify-center m-auto visible`
    }),
    className: `h-screen w-screen flex m-auto items-center ` + styles
  });
}

let make = PaymentLoader;

export {
  make,
}
/* react Not a pure module */
